import json5 from 'json5';

function getOccurrences(param, tag, service, servicesStructure, selectedReplaceOption) {
	let total = [];

	if (__DEBUG__)
		console.debug('Get occurrences', { param, tag, service, servicesStructure, selectedReplaceOption });

	servicesStructure.filter(f => {
		switch(selectedReplaceOption) {
			case 'insertion':
			case 'service':
			case 'value':
				return f.service.Oid === service.Oid;
			case 'param':
				return f.service?.JsonDefinition?.Parameters?.some(p => p.Name === param.Name && p.ParentServiceOid == param.ParentServiceOid && p.ParentServiceOutput == param.ParentServiceOutput) 
					|| f.service?.JsonDefinition?.ComplexParameters?.some(p => p.Name === param.Name && p.Type === param.Type);
		}
	}).map(f => {
		f.insertions.filter(i => {
			switch(selectedReplaceOption) {
				case 'insertion':
				case 'value':
					return i.insertion.Oid === tag.insertion.Oid;
				default:
					return true;
			}
		}).map(i => {
			i.tags.filter((t, tIdx) => {
				return selectedReplaceOption !== 'value' || tag.index === tIdx;
			}).map((t, tIdx) => {
				total.push({
					tag: t,
					index: t,
					service: f.service,
					insertion: i.insertion,
				})
			});
		});
	});

	return total;
}

function filterInsertionsByTemplateField(insertions, templateFieldIds) {
	return insertions.filter(f => {
		const hasTemplateString = templateFieldIds.some(id => `${f?.Ssml}`.indexOf(`[!${id}]`) > -1);

		if (hasTemplateString) return hasTemplateString;

		const ssml = document.createElement('div');
		ssml.innerHTML = f?.Ssml;
		
		const items = ssml.querySelectorAll('[templatefieldsassociation]');
		for(var i = 0; i < items.length; i++) {
			const node = items[i];
			const associations = json5.parse(node.getAttribute('templatefieldsassociation') || '{}');

			const hasAssociation = templateFieldIds.some(id => Object.keys(associations).some(f => associations[f] === id));

			if (hasAssociation) {
				return true;
			}
		}

		return false;
	});
}

export default {
	getOccurrences,
	filterInsertionsByTemplateField
};
